import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './GuideModal.css';

const IOSGuide = ({ onClose }) => {
  const steps = [
    {
      id: 1,
      title: 'STEP 1',
      description: '点击允许描述文件下载',
      tip: '在 Safari 浏览器中点击下载链接'
    },
    {
      id: 2,
      title: 'STEP 2',
      description: '打开 设置 - 通用 - VPN与设备管理',
      tip: '找到配置描述文件选项'
    },
    {
      id: 3,
      title: 'STEP 3',
      description: '选择并安装描述文件',
      tip: '点击描述文件进行安装'
    },
    {
      id: 4,
      title: 'STEP 4',
      description: '输入锁屏密码确认',
      tip: '使用您的设备密码授权'
    },
    {
      id: 5,
      title: 'STEP 5',
      description: '确认安装描述文件',
      tip: '按照提示完成安装'
    },
    {
      id: 6,
      title: 'STEP 6',
      description: '恭喜！安装成功',
      tip: '回到桌面即可使用应用'
    }
  ];

  return (
    <motion.div
      className="guide-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="guide-modal"
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="modal-header">
          <h2>iOS 安装指南</h2>
          <p>请按照以下步骤完成安装</p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              className="step-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="step-number-badge">{step.id}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                <p className="step-tip">{step.tip}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.button
          className="action-btn"
          onClick={onClose}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          我知道了
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default IOSGuide;

